import React from 'react';
import { Box, Typography, Switch } from '@mui/material';
import TuneIcon from '@mui/icons-material/Tune';
import TimerIcon from '@mui/icons-material/Timer';
import { GT_COLORS } from '../../../../components/groups-teams/shared/constants';

interface GroupFeatureConfigCardProps {
    checkOnMeEnabled: boolean | undefined;
    onToggle: (enabled: boolean) => void;
}

export const GroupFeatureConfigCard: React.FC<GroupFeatureConfigCardProps> = ({
    checkOnMeEnabled,
    onToggle,
}) => {
    return (
        <Box
            sx={{
                backgroundColor: GT_COLORS.cardBg,
                border: `1px solid ${GT_COLORS.border}`,
                borderRadius: '10px',
                padding: '20px',
            }}
        >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: '14px' }}>
                <TuneIcon sx={{ fontSize: '18px', color: GT_COLORS.primary }} />
                <Typography sx={{ fontSize: '14px', fontWeight: 600 }}>Feature Configuration</Typography>
            </Box>

            <Typography sx={{ fontSize: '13px', color: GT_COLORS.textMuted, mb: '16px' }}>
                Enable features for all teams in this group. Individual teams can override these settings.
            </Typography>

            <Box
                sx={{
                    border: `1px solid ${GT_COLORS.border}`,
                    borderRadius: '8px',
                    overflow: 'hidden',
                }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        padding: '12px 16px',
                        backgroundColor: GT_COLORS.headerBg,
                        borderBottom: `1px solid ${GT_COLORS.border}`,
                    }}
                >
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <TimerIcon sx={{ fontSize: '18px', color: GT_COLORS.primary }} />
                        <Typography sx={{ fontSize: '14px', fontWeight: 600 }}>Check On Me</Typography>
                    </Box>
                    {checkOnMeEnabled && (
                        <Box
                            sx={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                padding: '2px 8px',
                                borderRadius: '4px',
                                fontSize: '11px',
                                fontWeight: 500,
                                backgroundColor: GT_COLORS.greenLight,
                                color: GT_COLORS.green,
                            }}
                        >
                            Enabled
                        </Box>
                    )}
                </Box>

                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        padding: '14px 16px',
                    }}
                >
                    <Box>
                        <Typography sx={{ fontSize: '14px' }}>Enable Check On Me</Typography>
                        <Typography sx={{ fontSize: '12px', color: GT_COLORS.textFaint, mt: '1px' }}>
                            POM Users in this group's teams can start Check On Me timers. Teams can still override this setting individually.
                        </Typography>
                    </Box>
                    <Switch
                        checked={checkOnMeEnabled ?? false}
                        onChange={(e) => onToggle(e.target.checked)}
                        sx={{
                            '& .MuiSwitch-switchBase.Mui-checked': {
                                color: GT_COLORS.primary,
                            },
                            '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                                backgroundColor: GT_COLORS.primary,
                            },
                        }}
                    />
                </Box>
            </Box>
        </Box>
    );
};
